import { FC } from "react";
import { TextareaFormField } from "@blanket/components/formFields/FormFields";

type RegistrationRemarksFieldProps = {
  namePrefix: string;
  idPrefix: string;
};

/** Frivillige bemærkninger, lige inden datofelterne på alle seks blanketter. */
export const RegistrationRemarksField: FC<RegistrationRemarksFieldProps> = ({
  namePrefix,
  idPrefix,
}) => (
  <TextareaFormField
    name={`${namePrefix}.remarks`}
    label="Eventuelle bemærkninger"
    id={`${idPrefix}-input-remarks`}
  />
);
